<p-dialog
  header="Document Viewer"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [maximizable]="true"
  [resizable]="true"
  (onHide)="onClose()"
  class="document-viewer-dialog"
>
  <div class="document-viewer-content">
    <!-- Document Header -->
    <div class="document-header mb-4 p-4 bg-gray-50 rounded-lg">
      <div class="flex items-center justify-between">
        <div>
          <h3 class="text-lg font-semibold text-gray-900">
            {{ getDisplayName() }}
          </h3>
          <p class="text-sm text-gray-600">
            Size: {{ attachment?.size }} | Type:
            {{ getFileTypeDisplay(attachment?.type) }}
          </p>
        </div>
        <div class="flex gap-2">
          <button
            pButton
            type="button"
            icon="pi pi-download"
            label="Download"
            class="p-button-outlined p-button-sm"
            (click)="onDownload()"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-external-link"
            label="Open in New Tab"
            class="p-button-outlined p-button-sm"
            (click)="onOpenInNewTab()"
          ></button>
        </div>
      </div>
    </div>

    <!-- Document Content -->
    <div class="document-content h-full">
      <!-- Loading State -->
      @if (loading || !attachment) {
      <div class="loading-state h-full flex items-center justify-center">
        <div class="text-center">
          <div
            class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"
          ></div>
          <h3 class="text-lg font-medium text-gray-900 mb-2">
            Loading Document...
          </h3>
          <p class="text-gray-600">
            Please wait while we fetch the document from the server.
          </p>
        </div>
      </div>
      }

      <!-- PDF Viewer -->
      @if (!loading && attachment && isPdfFile()) {
      <div class="pdf-viewer h-full">
        <div
          class="pdf-container h-full bg-gray-100 rounded-lg overflow-hidden"
        >
          <pdf-viewer
            [src]="pdfSrc"
            [render-text]="true"
            [original-size]="false"
            [show-all]="true"
            [autoresize]="true"
            style="width: 100%; height: 100%;"
            (after-load-complete)="onPdfLoaded($event)"
            (error)="onPdfError($event)"
          ></pdf-viewer>
        </div>
      </div>
      }

      <!-- Other File Types (including Word documents) -->
      @if (!loading && attachment && !isPdfFile()) {
      <div
        class="other-file-viewer h-full flex items-center justify-center"
      >
        <div class="text-center">
          <i class="pi pi-file text-6xl text-gray-400 mb-4"></i>
          <h3 class="text-xl font-medium text-gray-900 mb-2">
            {{ getDisplayName() }}
          </h3>
          <p class="text-gray-600 mb-4">
            This file type cannot be previewed directly. Please download the
            file to view it.
          </p>
          <div class="bg-white p-6 rounded-lg shadow-sm max-w-md mx-auto">
            <h4 class="font-semibold text-gray-900 mb-3">
              File Information:
            </h4>
            <div class="space-y-2 text-sm text-gray-700">
              <p><strong>Name:</strong> {{ getDisplayName() }}</p>
              <p><strong>Size:</strong> {{ attachment.size }}</p>
              <p>
                <strong>Type:</strong>
                {{ getFileTypeDisplay(attachment.type) }}
              </p>
            </div>
          </div>
          <button
            pButton
            type="button"
            icon="pi pi-download"
            label="Download File"
            class="p-button-primary mt-4"
            (click)="onDownload()"
          ></button>
        </div>
      </div>
      }
    </div>
  </div>
</p-dialog>

